import { useState } from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import IconButton from "@mui/material/IconButton";
import { Link } from "react-router-dom";
import { getLaunchReadiness } from "../utils/launchReadiness";

const COLLAPSED_STORAGE_KEY = "InChat:launch-checklist-collapsed";

export default function LaunchReadinessChecklist({
  game,
  draftSettings,
  linkCopiedVersion = 0,
  compact = false,
  collapsible = false,
  onStepFocus,
}) {
  void linkCopiedVersion;
  const { items, doneCount, total, allDone } = getLaunchReadiness(
    game,
    draftSettings,
  );

  const [collapsed, setCollapsed] = useState(() => {
    const stored = localStorage.getItem(COLLAPSED_STORAGE_KEY);
    if (stored === null) {
      return true;
    }
    return stored === "1";
  });

  const stepByItem = {
    startPost: "start",
    published: "publish",
    linkCopied: "access",
  };

  const toggleCollapsed = () => {
    setCollapsed((current) => {
      const next = !current;
      localStorage.setItem(COLLAPSED_STORAGE_KEY, next ? "1" : "0");
      return next;
    });
  };

  return (
    <section
      className={`app-settings-card app-settings-card--launch${
        compact ? " app-settings-card--launch-compact" : ""
      }${collapsed ? " app-settings-card--launch-collapsed" : ""}`}
    >
      <div className="app-launch-checklist__head">
        <div className="app-launch-checklist__head-main">
          <h3 className="app-settings-card__title app-settings-card__title--left">
            Готов к запуску
          </h3>
          <span className="app-launch-checklist__progress">
            {doneCount}/{total}
          </span>
        </div>
        {collapsible ? (
          <IconButton
            size="small"
            className="app-launch-checklist__toggle"
            aria-label={collapsed ? "Развернуть рекомендации" : "Свернуть рекомендации"}
            aria-expanded={!collapsed}
            onClick={toggleCollapsed}
          >
            {collapsed ? <ExpandMoreIcon fontSize="small" /> : <ExpandLessIcon fontSize="small" />}
          </IconButton>
        ) : null}
      </div>

      {!collapsed ? (
        <>
          <p className="app-launch-checklist__note">
            Рекомендации перед запуском — не жёсткие требования. Опытным
            пользователям блок можно свернуть и открыть снова при необходимости.
          </p>

          {!compact ? (
            <p className="app-launch-checklist__intro">
              {allDone
                ? "Всё готово — можно отправлять ссылку команде."
                : "Пройдитесь по пунктам перед рассылкой ссылки сотрудникам."}
            </p>
          ) : null}

          <ul className="app-launch-checklist__list">
            {items.map((item) => {
              const Icon = item.done
                ? CheckCircleOutlineIcon
                : RadioButtonUncheckedIcon;
              const focusStep = stepByItem[item.id];

              return (
                <li
                  key={item.id}
                  className={`app-launch-checklist__item${
                    item.done ? " app-launch-checklist__item--done" : ""
                  }${focusStep && onStepFocus ? " app-launch-checklist__item--clickable" : ""}`}
                >
                  <Icon className="app-launch-checklist__icon" fontSize="small" />
                  <div className="app-launch-checklist__content">
                    {focusStep && onStepFocus ? (
                      <button
                        type="button"
                        className="app-launch-checklist__jump"
                        onClick={() => onStepFocus(focusStep)}
                      >
                        <strong>{item.label}</strong>
                      </button>
                    ) : (
                      <strong>{item.label}</strong>
                    )}
                    {!item.done && item.hint ? <p>{item.hint}</p> : null}
                  </div>
                </li>
              );
            })}
          </ul>

          {!compact ? (
            <p className="app-launch-checklist__footer">
              Инструкцию для сотрудников можно отправить вместе со ссылкой:{" "}
              <Link to="/dlya-sotrudnika">Инструкция для сотрудников</Link>
            </p>
          ) : null}
        </>
      ) : (
        <p className="app-launch-checklist__collapsed-hint">
          {allDone
            ? "Все рекомендации выполнены."
            : `Осталось ${total - doneCount} из ${total} рекомендаций.`}
        </p>
      )}
    </section>
  );
}
